import { WhatsappLogo, Phone } from "@phosphor-icons/react";
import { whatsappLink, telLink } from "@/lib/data";

// Sticky bottom bar — mobile only
const MobileBar = () => (
  <div
    data-testid="mobile-sticky-bar"
    className="fixed bottom-0 left-0 right-0 z-50 grid grid-cols-2 border-t border-black/10 bg-offwhite/95 backdrop-blur-xl md:hidden"
  >
    <a
      href={telLink()}
      data-testid="mobile-call-btn"
      className="flex items-center justify-center gap-2 py-4 text-xs font-semibold uppercase tracking-[0.16em] text-ink"
    >
      <Phone weight="fill" size={16} /> Call
    </a>
    <a
      href={whatsappLink()}
      target="_blank"
      rel="noopener noreferrer"
      data-testid="mobile-whatsapp-btn"
      className="flex items-center justify-center gap-2 bg-ink py-4 text-xs font-semibold uppercase tracking-[0.16em] text-offwhite"
    >
      <WhatsappLogo weight="fill" size={16} /> WhatsApp
    </a>
  </div>
);

export default MobileBar;
